// extracted by css-extract-rspack-plugin
export default {"disabled":"fKsBnFHjJ0iWtR8c","variantDefault":"FryDIULY9k4ASpPl","variantPrimary":"YQtlDFa1fo0UlPBl","variantText":"iID2cxw2yNYTNUw4"};